(function () {
  if (customElements.get('pdp-custom-subscription')) return;

  class PdpCustomSubscription extends HTMLElement {
    connectedCallback() {
      // Coming-soon mode: leave the (disabled) "Coming Soon" button as Liquid rendered it —
      // don't wire up the widget or overwrite the button label.
      if (this.dataset.comingSoon === 'true') return;
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;

      this.idInput = this.form.querySelector('input[name="id"]');
      this.button = this.form.querySelector('[type="submit"]');
      this.labelEl = this.button ? this.button.querySelector('span') : null;
      this.sepEl = this.button ? this.button.querySelector('.atc-price-sep') : null;
      this.priceEl = this.button ? this.button.querySelector('.atc-btn-price') : null;
      this.defaultLabel = this.labelEl ? this.labelEl.textContent : '';
      this.frequency = this.querySelector('[data-csw-frequency]');
      this.planPriceEl = this.querySelector('[data-csw-plan-price]');
      this.comparePriceEl = this.querySelector('[data-csw-compare-price]');

      var noteTemplate = this.querySelector('template[data-csw-note]');
      if (noteTemplate && noteTemplate.content.firstElementChild && this.button) {
        this.note = noteTemplate.content.firstElementChild.cloneNode(true);
        this.button.insertAdjacentElement('afterend', this.note);
      }

      this.deliverySpan = null;
      this.querySelectorAll('.pdp-csw__widget--sub .pdp-csw__benefit span').forEach(
        function (span) {
          if (!this.deliverySpan && span.textContent.indexOf('Delivered every') === 0) {
            this.deliverySpan = span;
          }
        }.bind(this)
      );

      var self = this;
      this.querySelectorAll('.pdp-csw__input').forEach(function (radio) {
        radio.addEventListener('change', function () {
          self.applyUi();
        });
      });
      if (this.frequency) {
        this.frequency.addEventListener('change', function () {
          self.updateDeliveryText();
        });
        this.updateDeliveryText();
      }

      this.onSubmit = this.onSubmit.bind(this);
      document.addEventListener('submit', this.onSubmit, true);

      this.applyUi();
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.onSubmit, true);
    }

    updateDeliveryText() {
      if (!this.frequency) return;
      var option = this.frequency.options[this.frequency.selectedIndex];
      if (!option) return;
      if (this.deliverySpan) {
        var match = option.textContent.match(/\d+/);
        var months = match ? parseInt(match[0], 10) : 1;
        this.deliverySpan.textContent =
          months === 1 ? 'Delivered every 30 days' : 'Delivered every ' + months + ' months';
      }
      if (this.planPriceEl && option.dataset.price) {
        this.planPriceEl.textContent = this.displayPrice(option.dataset.price);
      }
      if (this.comparePriceEl && option.dataset.comparePrice) {
        this.comparePriceEl.textContent = option.dataset.comparePrice;
      }
      this.syncThemePrice();
    }

    get isSubscription() {
      var radio = this.querySelector('.pdp-csw__input[value="subscription"]');
      return !!(radio && radio.checked);
    }

    applyUi() {
      if (this.isSubscription) {
        if (this.labelEl) this.labelEl.textContent = this.dataset.subscribeLabel;
        if (this.sepEl) this.sepEl.style.display = 'none';
        if (this.priceEl) this.priceEl.style.display = 'none';
        if (this.note) this.note.hidden = false;
      } else {
        if (this.labelEl) this.labelEl.textContent = this.defaultLabel;
        if (this.sepEl) this.sepEl.style.display = '';
        if (this.priceEl) this.priceEl.style.display = '';
        if (this.note) this.note.hidden = true;
      }
      this.syncThemePrice();
    }

    /* Update the theme's price elements (top .f-price + ATC button .btn-price) to
       match the current CSW selection — the chosen subscription frequency's price,
       or the one-time price. Mirrors the Skio app-block price-sync in theme.liquid. */
    syncThemePrice() {
      var moneyStr = '';
      var compareStr = '';
      if (this.isSubscription) {
        var opt = this.frequency ? this.frequency.options[this.frequency.selectedIndex] : null;
        moneyStr = opt && opt.dataset.price ? opt.dataset.price : (this.planPriceEl ? this.planPriceEl.textContent : '');
        compareStr = opt && opt.dataset.comparePrice ? opt.dataset.comparePrice : (this.dataset.subCompare || '');
      } else {
        moneyStr = this.dataset.onetimePrice || '';
        compareStr = this.dataset.onetimeCompare || '';
      }
      moneyStr = (moneyStr || '').trim();
      if (!moneyStr) return;

      function toCents(t) {
        t = (t || '').replace(/[^0-9.]/g, '');
        return t ? Math.round(parseFloat(t) * 100) : NaN;
      }
      var cents = toCents(moneyStr);
      var compareCents = toCents(compareStr);
      var onSale = !isNaN(cents) && !isNaN(compareCents) && compareCents > cents;
      var displayMoney = this.displayPrice(moneyStr);

      var scope = this.closest('product-info') || document;
      scope.querySelectorAll('.f-price').forEach(function (w) {
        if (w.closest('sticky-atc-bar')) return;
        w.classList.toggle('f-price--on-sale', onSale);
        var reg = w.querySelector('.f-price__regular .f-price-item--regular');
        var sale = w.querySelector('.f-price__sale .f-price-item--sale');
        var cmp = w.querySelector('.f-price__sale .f-price-item--regular');
        if (onSale) {
          if (sale) sale.textContent = displayMoney;
          if (cmp) cmp.innerHTML = '<s>' + compareStr + '</s>';
          if (reg) reg.textContent = '';
        } else {
          if (reg) reg.textContent = displayMoney;
          if (sale) sale.textContent = '';
        }
      });

      scope.querySelectorAll('[id^="CartBtnPrice-"], .btn-price').forEach(function (el) {
        el.textContent = ' - ' + displayMoney;
        el.style.display = '';
      });
    }

    /* Show the configurable "free" text (data-free-text) when a price is $0,
       otherwise return the formatted money string unchanged. */
    displayPrice(moneyStr) {
      var freeText = this.dataset.freeText || '';
      if (!freeText) return moneyStr;
      var v = parseFloat((moneyStr || '').replace(/[^0-9.]/g, ''));
      return v === 0 ? freeText : moneyStr;
    }

    onSubmit(event) {
      if (event.target !== this.form) return;
      if (event.defaultPrevented) return; // another widget already handled this submit
      if (!this.isSubscription) return;
      event.preventDefault();
      event.stopPropagation();
      this.addToCart();
    }

    /* Build the cart line item(s) for the current selection. Shared by addToCart and the
       store-wide subscription login-gate, which captures this before redirecting to login. */
    buildItems() {
      var isFirstOrder = this.dataset.firstOrder === 'true';
      var subItem = { id: parseInt(this.dataset.subVariant, 10), quantity: 1 };
      if (this.frequency && this.frequency.value) {
        var selectedOption = this.frequency.options[this.frequency.selectedIndex];
        // First-order customers add csw_atc_product → use data-atc-plan (its plan ID).
        // Returning customers add csw_product (select_product) → use the display plan directly.
        var planId =
          isFirstOrder && selectedOption && selectedOption.dataset.atcPlan
            ? selectedOption.dataset.atcPlan
            : this.frequency.value;
        subItem.selling_plan = parseInt(planId, 10);
      }
      // _csw_item drives the "FREE KIT WHEN SUBSCRIBING" cart-drawer note, which only
      // makes sense for first-order customers receiving the trial kit. Returning
      // customers add the full subscription product directly — no kit note.
      if (isFirstOrder) {
        subItem.properties = { _csw_item: '1' };
        if (this.dataset.cartNoteTitle && this.dataset.cartNoteBody) {
          subItem.properties._csw_note_title = this.dataset.cartNoteTitle;
          subItem.properties._csw_note_body = this.dataset.cartNoteBody;
        }
      }
      return [subItem];
    }

    addToCart() {
      if (this.button && this.button.getAttribute('aria-disabled') === 'true') return;

      var subItem = this.buildItems()[0];

      // A free ($0) selection (the first-order trial kit) is limited to one per cart.
      // If it's already there, warn and just open the drawer instead of stacking a
      // second $0 line. Paid selections are unaffected.
      var self = this;
      if (this.isFreeSelection()) {
        if (this.button) {
          this.button.classList.add('btn--loading');
          this.button.setAttribute('aria-disabled', 'true');
        }
        this.cartContainsVariant(subItem.id, function (already) {
          if (already) {
            if (self.button) {
              self.button.classList.remove('btn--loading');
              self.button.removeAttribute('aria-disabled');
            }
            self.showError(self.dataset.freeLimitText || 'You can only add 1 free item to your cart.');
            self.openCartDrawer();
            return;
          }
          self.submitItem(subItem);
        });
        return;
      }

      this.submitItem(subItem);
    }

    /* Whether the current selection costs $0 — used to cap free items at one per cart. */
    isFreeSelection() {
      var moneyStr = '';
      if (this.isSubscription) {
        var opt = this.frequency ? this.frequency.options[this.frequency.selectedIndex] : null;
        moneyStr = opt && opt.dataset.price ? opt.dataset.price : '';
      } else {
        moneyStr = this.dataset.onetimePrice || '';
      }
      var t = (moneyStr || '').replace(/[^0-9.]/g, '');
      if (!t) return false;
      return Math.round(parseFloat(t) * 100) === 0;
    }

    /* Look up the live cart and report whether the given variant is already a line item. */
    cartContainsVariant(variantId, callback) {
      var cartUrl = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart';
      var hasFox = window.FoxTheme && FoxTheme.utils && FoxTheme.utils.fetchConfig;
      var cfg = hasFox ? FoxTheme.utils.fetchConfig('json', 'GET') : { headers: { Accept: 'application/json' } };
      fetch(cartUrl, cfg)
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var found = (cart.items || []).some(function (item) {
            return item.variant_id === variantId;
          });
          callback(found);
        })
        .catch(function () {
          callback(false);
        });
    }

    openCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') {
        drawer.show(this.button);
      }
    }

    submitItem(subItem) {
      var items = [subItem];

      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
      );

      var hasFox = window.FoxTheme && FoxTheme.utils && FoxTheme.utils.fetchConfig;
      var config = hasFox
        ? FoxTheme.utils.fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify({
        items: items,
        sections: sections,
        sections_url: window.location.pathname
      });

      var addUrl = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_add_url) || '/cart/add';
      var cartUrl = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart';

      var self = this;
      if (this.button) {
        this.button.classList.add('btn--loading');
        this.button.setAttribute('aria-disabled', 'true');
      }

      fetch(addUrl, config)
        .then(function (response) {
          return response.json();
        })
        .then(function (parsed) {
          if (parsed.status) {
            self.showError(parsed.description || parsed.message || 'Unable to add to cart');
            return;
          }
          var cartConfig = hasFox ? FoxTheme.utils.fetchConfig('json', 'GET') : { headers: { Accept: 'application/json' } };
          return fetch(cartUrl, cartConfig)
            .then(function (response) {
              return response.json();
            })
            .then(function (cartJson) {
              cartJson['sections'] = parsed['sections'];
              if (window.FoxTheme && FoxTheme.pubsub) {
                FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
              }
              document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsed } }));
              var drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.show === 'function') {
                drawer.show(self.button);
              } else {
                window.location.href = cartUrl;
              }
            });
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          if (self.button) {
            self.button.classList.remove('btn--loading');
            self.button.removeAttribute('aria-disabled');
          }
        });
    }

    showError(message) {
      var wrapper = this.form.closest('.product-form');
      var errorEl = wrapper ? wrapper.querySelector('.product-form__error-message') : null;
      if (errorEl) {
        errorEl.removeAttribute('hidden');
        errorEl.innerText = message;
        var errorWrapper = wrapper.querySelector('.product-form__error-message-wrapper');
        if (errorWrapper) errorWrapper.removeAttribute('hidden');
      } else {
        alert(message);
      }
    }
  }

  customElements.define('pdp-custom-subscription', PdpCustomSubscription);
})();
